import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const onetimeSecret = defineConnector({
  identifier: "onetimeSecret",
  name: "Onetime Secret",
  tagLine: "Secure secret sharing",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://onetimesecret\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Onetime Secret](https://onetimesecret.com/), go to your **Account** page, and find your API token. You authenticate with your account email and this token.",
        },
      ],
    },
    {
      title: "Enter your account details",
      items: [
        {
          kind: "input",
          label: "Account email",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://onetimesecret.com/api/v1/status",
  },
});
